import IconFileCode from "components/icons/icn-file-code.icon";
import type { UploadDoiInventoryPolicy } from "components/import-export-json/doi-inventory-policy.types";
import { validateDoiInventoryPolicyDelimiter } from "components/import-export-json/doi-inventory-policy.utils";
import { forwardRef } from "react";
import intl from "react-intl-universal";
import { useCSVReader } from "react-papaparse";
import StyledCSVReader from "./styled";

interface FileUploadDoiInventoryPolicyProps {
  handleReadFile: (data: IReadFileDoiInventoryPolicy) => void;
  setCsv: (xls: UploadDoiInventoryPolicy[]) => void;
  setErrors: (error: string[]) => void;
  setFileName: (fileName: string) => void;
}

type IAcceptedFile = {
  acceptedFile: File | null;
  getRootProps: () => React.HTMLProps<HTMLDivElement>;
};

type IReadFileDoiInventoryPolicy = {
  data: UploadDoiInventoryPolicy[];
  errors: [];
  meta: [];
};

const StyledCSVReaderWithRef = forwardRef<HTMLDivElement>((props) => (
  <StyledCSVReader {...props} />
));

const FileUploadDoiInventoryPolicy = ({
  handleReadFile,
  setCsv,
  setErrors,
  setFileName,
}: FileUploadDoiInventoryPolicyProps) => {
  const { CSVReader } = useCSVReader();

  const handleUploadFile = (fileData: IReadFileDoiInventoryPolicy) => {
    if (fileData.data.length > 2000) {
      setErrors([intl.get("master-data.general-configuration.maxLineError")]);
    } else {
      const _fileData = fileData.data.filter((item) =>
        Object.values(item).some((value) => value && value.toString().trim() !== "")
      ) as unknown as UploadDoiInventoryPolicy;

      setCsv([_fileData]);
      handleReadFile({ data: [_fileData], errors: [], meta: [] });
    }
  };

  return (
    <CSVReader
      onUploadAccepted={handleUploadFile}
      config={{
        encoding: "iso-8859-1",
        header: true,
        delimiter: validateDoiInventoryPolicyDelimiter(),
      }}
    >
      {({ acceptedFile, getRootProps }: IAcceptedFile) => {
        if (acceptedFile?.name) {
          setFileName(acceptedFile.name);
        }
        return (
          <StyledCSVReaderWithRef {...getRootProps()}>
            <label>{intl.get("master-data.general.stockPolicyModal.archive")}</label>
            <div className="input-container">
              {!acceptedFile && (
                <span>{intl.get("master-data.general.stockPolicyModal.searchArchive")}</span>
              )}
              {acceptedFile && <span>{acceptedFile.name}</span>}
              <div className="button-upload">
                <IconFileCode />
                <span>{intl.get("master-data.general.stockPolicyModal.select")}</span>
              </div>
            </div>
            <p>{intl.get("exportImportModal.masterData.maxLines")}</p>
          </StyledCSVReaderWithRef>
        );
      }}
    </CSVReader>
  );
};

export { FileUploadDoiInventoryPolicy };
